import { Injectable } from "@angular/core";
import { Flacon } from "src/app/domain/flacon";
import { mapper } from "src/app/tools/mapping/mapper";
import { db } from "../db";
import { FlaconEntity } from "../flacon.entity";
import { PrelevementEntity } from "../prelevement.entity";

@Injectable({
    providedIn: 'root',
})
export class FlaconRepository {


    constructor() { }

    async getFlaconById(id: number) {

        return await db.flacons.where('Id').equals(id).first(async ze => {
            const z = mapper.map(ze, FlaconEntity, Flacon);
            return z;
        });
    }

    async getFlaconEntityByCode(code: string) {
        return await db.flacons.where('Code').equals(code).first(async ze => {
            return ze;
        });
    }

    async checkIfBarcodeExists(code: string) {
        return await db.flacons.where('Barcode').equals(code).first(async ze => {
            return ze;
        });
    }

    async attachFlacon(flacon: Flacon, prel: PrelevementEntity) {
        let flaconId: number;
        const oe = mapper.map(flacon, Flacon, FlaconEntity);

        // const ae = await this.prelevementRepository.getPrelevementEntityById(prelId);
        flaconId = await db.flacons.add(oe);
        prel.FlaconIds = prel?.FlaconIds ? [...prel.FlaconIds, flaconId] : [flaconId]
        await db.prelevements.update(prel.Id!, {
            FlaconIds: prel?.FlaconIds
        });
        return flaconId;
    }

    async clearBarCode(id: number) {
        db.flacons.update(id, {
            Barcode: ''
        });
    }
}